export default __webpack_public_path__ + "static/media/discover.fcb8bc91.svg";